/**
 * Load-status → badge tone mapping. The five lifecycle states use the
 * `--color-status-*` semantic tokens (README 0.4.3) so they stay themeable.
 */
export type LoadStatus = "draft" | "locked" | "booked" | "dispatched" | "completed";

export const LOAD_STATUSES: LoadStatus[] = [
  "draft",
  "locked",
  "booked",
  "dispatched",
  "completed",
];

const TONE_BY_STATUS: Record<LoadStatus, string> = {
  draft: "status-draft",
  locked: "status-locked",
  booked: "status-booked",
  dispatched: "status-dispatched",
  completed: "status-completed",
};

/** Tailwind color-token name (e.g. `status-booked`) for the status badge. */
export function statusTone(status: string): string {
  return TONE_BY_STATUS[status as LoadStatus] ?? "muted";
}

/** Human label for a load status (localization keys arrive in Phase 8). */
export function statusLabel(status: string): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}
